import styles from './Toast.module.css'

interface IToastProps {
  title?: string
  description?: string
}

export const Toast = ({ title, description }: IToastProps) => {
  return (
    <div className={styles.container}>
      {title && <h6 className={styles.title}>{title}</h6>}
      {description && <p className={styles.description}>{description}</p>}
    </div>
  )
}
